<div
    *ngIf="answer.type === 'single_select' || answer.type === 'multi_select'"
    style="display: flex; flex-direction: column"
>
    <h6
        *ngIf="answer.label"
        [innerHTML]="answer.label.replace('{brand}', brandName)"
    ></h6>
    <div
        *ngFor="let option of answer?.options"
        [class]="data[option.key] === true && option.answer ? 'full-width' : ''"
    >
        <label
            *ngIf="data[option.key]"
            nz-checkbox
            class="select"
            [ngModel]="data[option.key] | bool"
            [name]="field + '_' + option.key"
            disabled
            >{{ option.value }}
        </label>

        <consultation-answer
            *ngIf="data[option.key] === true && option.answer"
            [field]="field"
            [data]="data"
            [answer]="option.answer"
            [brand]="brand"
        ></consultation-answer>
    </div>
</div>

<div *ngIf="answer.type === 'list'">
    <div *ngFor="let item of answer.items" class="list-answers">
        <consultation-answer
            [field]="field"
            [data]="data"
            [answer]="item"
            [brand]="brand"
            [question]="question"
            [allAnswers]="allAnswers"
        ></consultation-answer>
    </div>
</div>

<div *ngIf="answer.type === 'radio'" class="sub-item">
    <p>{{ answer.label }}</p>
    <nz-radio-group
        [name]="field + '_' + answerName"
        [ngModel]="data[answerName]"
    >
        <label
            nz-radio
            *ngFor="let option of answer.options"
            [nzValue]="option.key"
            disabled
            >{{ option.value }}</label
        >
    </nz-radio-group>

    <div *ngFor="let optionAnswer of optionAnswers | keyvalue">
        <consultation-answer
            *ngIf="optionAnswer.value && optionAnswer.key === data[answerName]"
            [field]="field"
            [data]="data"
            [answer]="optionAnswer.value"
            [brand]="brand"
        ></consultation-answer>
    </div>
</div>

<div *ngIf="answer.type === 'text'" class="sub-item">
    <h6 *ngIf="answer.label">{{ answer.label }}</h6>

    <nz-input-group class="ant-input-affix-wrapper-textarea-with-clear-btn">
        <textarea
            nz-input
            [name]="field + '_' + answerName"
            [ngModel]="data[answerName]"
            [placeholder]="answer.placeholder ? answer.placeholder : ''"
            disabled
            required
            nzAutosize
        ></textarea>
    </nz-input-group>
</div>

<div *ngIf="answer.type === 'number'" class="sub-item">
    <p *ngIf="answer.label">{{ answer.label }}</p>

    <nz-input-number
        style="width: 100%"
        [name]="field + '_' + answerName"
        [ngModel]="data[answerName]"
        [nzMin]="1"
        [nzMax]="100000"
        [nzStep]="1"
        disabled
        required
    ></nz-input-number>
</div>

<div *ngIf="answer.type === 'date'" class="sub-item">
    <h4 *ngIf="answer.label">{{ answer.label }}</h4>

    <nz-date-picker
        [name]="field + '_' + answerName"
        [ngModel]="data[answerName]"
        disabled
        required
    ></nz-date-picker>
</div>

<div *ngIf="answer.type === 'dropdown'" class="sub-item">
    <h4 *ngIf="answer.label">{{ answer.label }}</h4>

    <nz-select
        [name]="field + '_' + answerName"
        [ngModel]="data[answerName]"
        nzAllowClear
        [nzPlaceHolder]="answer.placeholder || ''"
        disabled
        style="width: 100%"
        required
    >
        <nz-option
            *ngFor="let option of answer.options"
            [nzValue]="option.key"
            [nzLabel]="option.value"
        ></nz-option>
    </nz-select>
</div>

<div *ngIf="answer.type === 'consent-check'" class="sub-item">
    <h4 *ngIf="answer.label">{{ answer.label }}</h4>

    <label
        nz-checkbox
        [name]="field + '_' + answerName"
        [ngModel]="data['accept']"
        disabled
        >{{ answer.agreeLabel || 'I Agree' }}</label
    >

    <input
        type="text"
        class="hidden"
        [name]="field + '_validAnswer'"
        [ngModel]="isAccept"
        required
    />
</div>

<div *ngIf="answer.type === 'measure'" class="measure sub-item">
    <consultation-answer
        *ngIf="
            !(
                answer.value.name === 'height' &&
                data['heightUnit'] === 'feetIn'
            );
            else feetInTmp
        "
        class="value"
        [field]="field"
        [data]="data"
        [answer]="answer.value"
    ></consultation-answer>
    <span class="divider" [innerHTML]="answer.division"></span>
    <consultation-answer
        class="unit"
        [field]="field"
        [data]="data"
        [answer]="answer.unit"
    ></consultation-answer>

    <ng-template #feetInTmp>
        <div style="width: 45%">
            <consultation-answer
                [data]="data"
                [answer]="{ type: 'feetIn', size: 'medium' }"
            ></consultation-answer>
        </div>
    </ng-template>
</div>

<div *ngIf="answer.type === 'feetIn'" class="feetIn">
    <nz-input-number
        style="flex: 0.5"
        [name]="field + '_feet'"
        [ngModel]="data['feet']"
        [nzSize]="answer.size"
        nzPlaceHolder="feet"
        [nzMax]="answer.max || 'Infinity'"
        [nzMin]="0"
        disabled
        required
    ></nz-input-number>

    <nz-input-number
        style="flex: 0.5"
        [name]="field + '_inches'"
        [ngModel]="data['inches']"
        [nzSize]="answer.size"
        nzPlaceHolder="inches"
        [nzMax]="answer.max || 'Infinity'"
        [nzMin]="0"
        disabled
        required
    ></nz-input-number>
</div>

<div *ngIf="answer.type === 'measure-list'" class="measure sub-item">
    <consultation-answer
        class="value"
        [field]="field"
        [data]="data"
        [answer]="answer.value1"
    ></consultation-answer>
    <span class="unit-label" [innerHTML]="answer.unit1"></span>
    <consultation-answer
        class="value"
        [field]="field"
        [data]="data"
        [answer]="answer.value2"
    ></consultation-answer>
    <span class="unit-label" [innerHTML]="answer.unit2"></span>
</div>

<div *ngIf="answer.type === 'calculated'" class="calculated">
    <p class="span-box">
        {{ answer.label }}: {{ answer.answer.formula(data) }}
    </p>
</div>

<div *ngIf="answer.type === 'bmi'" class="bmi sub-item">
    <p *ngIf="bmiConfig.showWeight !== false && bmiWeightValue">
        {{ bmiConfig.weightLabel || 'Weight' }}: {{ bmiWeightValue }}
    </p>
    <p *ngIf="bmiConfig.showHeight !== false && bmiHeightValue">
        {{ bmiConfig.heightLabel || 'Height' }}: {{ bmiHeightValue }}
    </p>
    <p
        *ngIf="bmiConfig.showCalculatedValues !== false && bmiValue"
        class="span-box"
    >
        {{ bmiConfig.bmiLabel || 'BMI' }}: {{ bmiValue }}
    </p>
</div>

<div *ngIf="answer.type === 'text_list'" class="row container">
    <p>
        {{ answer.label }}
    </p>

    <div
        class="row answers center"
        *ngFor="let item of data['list']; let i = index"
    >
        <div class="full-width line">
            <nz-input-group nzSearch>
                <input
                    type="text"
                    nz-input
                    [name]="field + '_list_' + i"
                    [ngModel]="item.name"
                    [placeholder]="answer.inputPlaceholder"
                    disabled
                    required
                />
            </nz-input-group>
        </div>
    </div>
</div>

<div *ngIf="answer.type === 'transfer-rx'" class="row full-width">
    <div class="card padded col half">
        <img
            class="rx-img"
            alt="transfer rx file"
            [src]="transferRxFile.buffer"
        /><img />
    </div>

    <textarea
        class="card padded col half rx-text"
        [class.checked]="data[answer.option2.name]"
        nz-input
        [name]="field + '_' + answer.option2.name"
        [ngModel]="data[answer.option2.name]"
        [placeholder]="
            answer.option2.placeholder ? answer.option2.placeholder : ''
        "
        disabled
        required
        nzAutosize
    ></textarea>
</div>

<div *ngIf="answer.type === 'branch'">
    <div *ngFor="let item of answer.items">
        <consultation-answer
            *ngIf="checkCondition(item.condition)"
            [data]="data"
            [answer]="item.answer"
        ></consultation-answer>
    </div>
</div>

<div *ngIf="answer.type === 'healthCard'">
    <nz-descriptions nzTitle [nzColumn]="1">
        <nz-descriptions-item nzTitle="HC number" [nzSpan]="1"
            ><span>{{ data.hcNum }}</span></nz-descriptions-item
        >
        <nz-descriptions-item
            *ngIf="data.hcType == 'Ontario'"
            nzTitle="HC symbol"
            [nzSpan]="1"
            ><span>{{ data.hcVer }}</span></nz-descriptions-item
        >
        <nz-descriptions-item
            *ngIf="data.hcType == 'Non-Ontario'"
            nzTitle="Province"
            [nzSpan]="1"
            ><span>{{ data.hcProv }}</span></nz-descriptions-item
        >
        <nz-descriptions-item nzTitle="Issue Date" [nzSpan]="1"
            ><span>{{ data.hcEff }}</span></nz-descriptions-item
        >
        <nz-descriptions-item nzTitle="Expiry Date" [nzSpan]="1"
            ><span>{{ data.hcExp }}</span></nz-descriptions-item
        >
    </nz-descriptions>
</div>

<div
    *ngIf="
        question?.type === 'file_upload' ||
        question?.type === 'image_list' ||
        answer?.type === 'esign'
    "
>
    <div class="gallery">
        <ng-container *ngFor="let file of files">
            <div class="img-container">
                <img
                    [ngStyle]="{ visibility: file.loading ? 'hidden' : '' }"
                    [src]="file.path | file | async"
                    [alt]="file.name"
                    (click)="openModal(file.path)"
                    (load)="onLoad(file.name)"
                />
                <div *ngIf="file.loading" class="loading-spinner">
                    Loading...
                </div>
            </div>
        </ng-container>
    </div>
</div>

<div class="flex flex-col gap-2" *ngIf="answer?.type === 'witness-esign'">
    <p><b>Witness:</b></p>
    <p>
        {{ answer.witness.name }}
    </p>
    <div>
        <img
            [src]="'assets/signatures/' + answer.witness.sig"
            [alt]="answer.witness.name"
            style="height: 120px"
        />
    </div>
</div>

<!-- Image modal -->
<div class="modal" *ngIf="isModalOpen" (click)="closeModal()">
    <span class="close" (click)="closeModal()">&times;</span>
    <img class="modal-content" [src]="selectedImage | file | async" />
</div>
